import {Order, OrderAttributesValue, OrderAttributesView} from "@/gql/gen";
import {arrayIndex} from "@/core/util/arrayIndex";

export default function useOrder(order: Order): OrderModel {
    const ATTR_VALUE = arrayIndex(order.ATTRS, 'CODE', 'VALUE') as OrderAttributesValue
    const ATTR_VIEW = arrayIndex(order.ATTRS, 'CODE', 'VALUE_VIEW') as OrderAttributesView
    return {
        ...order,
        ATTR_VALUE,
        ATTR_VIEW,
    }
}

export type OrderModel = Order & {
    ATTR_VALUE: OrderAttributesValue
    ATTR_VIEW: OrderAttributesView,
}
